import React from 'react'
import opacitylogo from '../Assets/opacitylogo.png'
import foodlinklogo from '../Assets/foodlinklogo.png'
import ogclogo from '../Assets/ogclogo.png'
import { useTranslation } from 'react-i18next'

const Marque = (props) => {
    const {t, i18n} = useTranslation();
    const isRTL = i18n.language === 'ar';
    return (
        <div className={` ${props.padd}`}>
            <div className={`${props.motherclassName} ${isRTL ? 'rtl' : 'ltr'} relative overflow-visible rounded-[40px]`}>
                {/* corners rounded top-right*/}
                <div className=" absolute z-40
                    -top-[11px] -right-[11px] w-0 h-0 rotate-45
                    sm:-top-[21px] sm:-right-[21px]  
                    border-r-[10px] border-r-transparent border-t-[10px] border-t-transparent border-l-[10px] border-l-transparent border-b-[10px] border-b-white
                    sm:border-r-[20px] sm:border-r-transparent sm:border-t-[20px] sm:border-t-transparent sm:border-l-[20px] sm:border-l-transparent sm:border-b-[20px] sm:border-b-white
                    "
                >
                </div>
                {/* corners rounded bottom-right*/}
                <div className=" absolute z-40 -rotate-45
                    -bottom-[11px] -right-[11px] w-0 h-0
                    sm:-bottom-[21px] sm:-right-[21px]  
                    border-r-[10px] border-r-transparent border-t-[10px] border-t-white border-l-[10px] border-l-transparent border-b-[10px] border-b-transparent
                    sm:border-r-[20px] sm:border-r-transparent sm:border-t-[20px] sm:border-t-white sm:border-l-[20px] sm:border-l-transparent sm:border-b-[20px] sm:border-b-transparent
                    "
                ></div>
                {/* corners rounded top-left*/}
                <div className=" absolute z-40
                    -top-[11px] -left-[11px] w-0 h-0 rotate-45
                    sm:-top-[21px] sm:-left-[21px]  
                    border-r-[10px] border-r-white border-t-[10px] border-t-transparent border-l-[10px] border-l-transparent border-b-[10px] border-b-transparent
                    sm:border-r-[20px] sm:border-r-white sm:border-t-[20px] sm:border-t-transparent sm:border-l-[20px] sm:border-l-transparent sm:border-b-[20px] sm:border-b-transparent
                    "
                >
                </div>
                {/* corners rounded bottom-left*/}
                <div className=" absolute z-40 -rotate-45
                    -bottom-[11px] -left-[11px] w-0 h-0
                    sm:-bottom-[21px] sm:-left-[21px]  
                    border-r-[10px] border-r-white border-t-[10px] border-t-transparent border-l-[10px] border-l-transparent border-b-[10px] border-b-transparent
                    sm:border-r-[20px] sm:border-r-white sm:border-t-[20px] sm:border-t-transparent sm:border-l-[20px] sm:border-l-transparent sm:border-b-[20px] sm:border-b-transparent
                    "
                ></div>
                <div className='h-[200%] aspect-square absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10'>
                    <img src={opacitylogo} alt='marque' className='w-full h-full' />
                </div>
                <div className='h-[50%] w-1/4  flex items-center justify-center'>
                    <img src={foodlinklogo} alt='marque' className='h-full ' />
                </div>
                <div className='h-[100%] w-2/4 p-0 md:p-4 flex items-center justify-center'>
                    <h1 className={`my-0 ${props.className1} text-white font-bold text-center`}>{t('homepage.marque')}</h1>
                </div>
                <div className='h-[50%] w-1/4  flex items-center justify-center'>
                    <img src={ogclogo} alt='marque' className='h-full ' />
                </div>
            </div>
        </div>
    )
}

export default Marque